import { Component } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'worldarchery-calendar';
  banner = environment.assetsBasePath + '/modules/custom/wa_angular/app/assets/images/banner.jpg';
}
